module.exports = __webpack_public_path__ + "static/img/down.9d5ca333.svg";